import React from 'react'
import { Spinner } from '@chakra-ui/react'

function UmSpinner() {
    return (
        <Spinner
            thickness='4px'
            speed='0.5s'
            emptyColor='var(--secondary-color)'
            color='orange'
            size='xl'
        />
    )
}

export default UmSpinner
